import React from 'react';

function QuickStatsPanel({
  activeTab,
  data,
  selectedCount,
  onRefresh,
  onBulkDelete,
  onSelectAll,
  isAllSelected
}) {
  const getTabStats = () => {
    switch (activeTab) {
      case 'songs':
        return {
          totalPlays: data.reduce((sum, song) => sum + (song.play_count || 0), 0),
          avgDuration: data.length
            ? Math.round(data.reduce((sum, song) => sum + (song.duration_seconds || 0), 0) / data.length)
            : 0,
        };
      case 'albums':
        return {
          totalTracks: data.reduce((sum, album) => sum + (album.track_count || 0), 0),
          avgYear: data.length
            ? Math.round(data.reduce((sum, album) => sum + (album.release_year || 0), 0) / data.length)
            : 0,
        };
      case 'artists':
        return {
          totalAlbums: data.reduce((sum, artist) => sum + (artist.album_count || 0), 0),
          countries: new Set(data.map(artist => artist.country).filter(Boolean)).size,
        };
      default:
        return {};
    }
  };

  const stats = getTabStats();

  return (
    <div className="mb-6 p-5 rounded-xl" style={{ background: '#111', border: '1px solid #1f1f1f' }}>
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <h2 className="text-lg font-black text-white uppercase tracking-tight">
              {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
            </h2>
            <span
              className="text-xs font-bold px-2 py-0.5 rounded"
              style={{ background: 'rgba(220,38,38,0.15)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}
            >
              {data.length} total
            </span>
          </div>

          <div className="flex flex-wrap gap-4">
            {activeTab === 'songs' && (
              <>
                <div className="flex items-center gap-2">
                  <span className="text-xs uppercase tracking-wider" style={{ color: '#6b7280' }}>Plays</span>
                  <span className="text-sm font-bold text-white">{stats.totalPlays?.toLocaleString()}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs uppercase tracking-wider" style={{ color: '#6b7280' }}>Avg Duration</span>
                  <span className="text-sm font-bold text-white font-mono">
                    {Math.floor(stats.avgDuration / 60)}:{String(stats.avgDuration % 60).padStart(2, '0')}
                  </span>
                </div>
              </>
            )}
            {activeTab === 'albums' && (
              <>
                <div className="flex items-center gap-2">
                  <span className="text-xs uppercase tracking-wider" style={{ color: '#6b7280' }}>Tracks</span>
                  <span className="text-sm font-bold text-white">{stats.totalTracks}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs uppercase tracking-wider" style={{ color: '#6b7280' }}>Avg Year</span>
                  <span className="text-sm font-bold text-white">{stats.avgYear}</span>
                </div>
              </>
            )}
            {activeTab === 'artists' && (
              <>
                <div className="flex items-center gap-2">
                  <span className="text-xs uppercase tracking-wider" style={{ color: '#6b7280' }}>Albums</span>
                  <span className="text-sm font-bold text-white">{stats.totalAlbums}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs uppercase tracking-wider" style={{ color: '#6b7280' }}>Countries</span>
                  <span className="text-sm font-bold text-white">{stats.countries}</span>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          {selectedCount > 0 && (
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium" style={{ color: '#f87171' }}>{selectedCount} selected</span>
              <button
                onClick={onSelectAll}
                className="px-3 py-1.5 rounded-lg text-sm transition-all"
                style={{ background: '#1a1a1a', color: '#9ca3af', border: '1px solid #2a2a2a' }}
              >
                {isAllSelected ? 'Deselect All' : 'Select All'}
              </button>
              <button
                onClick={onBulkDelete}
                className="px-3 py-1.5 rounded-lg text-sm font-medium transition-all"
                style={{ background: 'rgba(220,38,38,0.12)', color: '#f87171', border: '1px solid rgba(220,38,38,0.25)' }}
              >
                Delete Selected
              </button>
            </div>
          )}

          <button
            onClick={onRefresh}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-all"
            style={{ background: '#1a1a1a', color: '#9ca3af', border: '1px solid #2a2a2a' }}
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuickStatsPanel;